import type { NavigateFunction } from 'react-router-dom';

let appNavigateFn: NavigateFunction | null = null;

export function registerAppNavigate(fn: NavigateFunction) {
  appNavigateFn = fn;
}

export function unregisterAppNavigate() {
  appNavigateFn = null;
}

/** SPA navigation from outside RouterProvider (e.g. JustCall dialer host). */
export function appNavigate(to: string) {
  if (appNavigateFn) {
    appNavigateFn(to);
  } else {
    window.location.assign(to);
  }
}
